module.exports = "/assets/data/4f6973fb1a54e5537ac422b8c0a09964-W1G.data.json";